"use strict";
// anyerror.ts -- code for handling any error
Object.defineProperty(exports, "__esModule", { value: true });
exports.toString = toString;
exports.extractErrorProperty = extractErrorProperty;
exports.causedByPermissionDenied = causedByPermissionDenied;
function copyProps(propList, src, dest) {
    propList.forEach(propName => {
        const srcVal = src[propName];
        if (srcVal !== undefined) {
            dest[propName] = srcVal;
        }
    });
}
// Ugh.  Convert Error's non-enumerable properties into
// enumerable ones so they get logged correctly.
function JSONreplacer(key, value) {
    if (value instanceof Error) {
        const flatErr = {};
        const propErr = value;
        const preNames = ['name', 'message',];
        const postNames = ['stack', 'cause'];
        copyProps(preNames, propErr, flatErr);
        const propNames = Object.getOwnPropertyNames(propErr);
        propNames.forEach(propName => {
            if (!postNames.includes(propName)) {
                const propVal = propErr[propName];
                flatErr[propName] = propVal;
            }
        });
        copyProps(postNames, propErr, flatErr);
        return flatErr;
    }
    if (key === 'stack' && typeof value === 'string') {
        const nv = value.replace(/\/home\/pat\/bitiotic\/projects\/numbets\/alpha/gu, '{}');
        const stackArr = nv.split('\n');
        if (stackArr.length <= 1) {
            return nv;
        }
        return stackArr
            .map(s => s.trim()) // eat leading/trailing whitespace
            .slice(1); // remove the Name+Message entry
    }
    return value;
}
function toString(err) {
    try {
        return JSON.stringify(err, JSONreplacer, 4);
    }
    catch (_stringifyError) {
        return '<stringify error>';
    }
}
// Find (string) value of given property on the given err-ish object.  The property is
// found if directly on the Error or embedded in an "errorInfo" sub-object.
function extractErrorProperty(err, propname) {
    while (err) {
        if (typeof err === 'object' && err !== null) {
            const errobj = err;
            const s = errobj[propname];
            if (typeof s === 'string') {
                return s;
            }
            const cause = errobj['cause'];
            if (cause) {
                err = cause;
            }
            else {
                err = null;
            }
        }
    }
    return null;
}
// Test is a (chained) error was caused by a Firebase "Permission Denied"
function causedByPermissionDenied(err) {
    const code = extractErrorProperty(err, 'code');
    return (code === 'permission-denied') || (code === 'auth/permission-denied');
}
//# sourceMappingURL=anyerror.js.map